import React from 'react';

export const RabbitMQIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
    <path d="M22.5 10.5h-3V7.5a1.5 1.5 0 0 0-1.5-1.5h-3V3a1.5 1.5 0 0 0-1.5-1.5h-3A1.5 1.5 0 0 0 9 3v3H6a1.5 1.5 0 0 0-1.5 1.5v3h-3A1.5 1.5 0 0 0 0 12v3a1.5 1.5 0 0 0 1.5 1.5h3V21A1.5 1.5 0 0 0 6 22.5h12a1.5 1.5 0 0 0 1.5-1.5v-4.5h3A1.5 1.5 0 0 0 24 15v-3a1.5 1.5 0 0 0-1.5-1.5z" />
  </svg>
);

export const N8NIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14.5v-5l-3 3-1.41-1.41L10.17 9.5H7v-2h6v6l3-3 1.41 1.41L13.83 15.5H17v2h-6z" />
  </svg>
);

export const StrapiIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
    <path d="M8 1h12.5v7.5H16V13H8V8.5h4.5V5H8V1zm0 7.5H3.5V21H16v-4.5h4.5V9H16v4.5H8V8.5zM3.5 8.5V4.25L7.75 8.5H3.5z" />
  </svg>
);

export const MedusaIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
    <path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z" />
  </svg>
);

export const OdooIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
    <path d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"/>
  </svg>
);

export const IdurarIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
    <path d="M4 4h4v16H4V4zm6 0h10a2 2 0 012 2v5a2 2 0 01-2 2h-4l4 7h-3.5l-3.8-7H10V4zm3 2.5v4h6v-4h-6z"/>
  </svg>
);

export const FrappeEducationIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
    <path d="M12 3L1 9l11 6 9-4.91V17h2V9L12 3zM5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82z"/>
  </svg>
);

export const RedisIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
    <path d="M10.5 2.661l.54.997-1.797.644 2.409.166.54.997-1.797.644 2.409.166.002.009L10.5 6.88l-2.894-.963 2.006-.735L7.2 4.99l2.006-.735L7.2 4.06l3.3-1.399zM12 21.593c-5.4-2.7-8.4-4.8-8.4-7.2V9l8.4-3.6L20.4 9v5.4c0 2.4-3 4.5-8.4 7.193zM12 7.2L5.4 9.9v4.5c0 1.5 2.1 3 6.6 5.4 4.5-2.4 6.6-3.9 6.6-5.4V9.9L12 7.2z" />
  </svg>
);

const PRODUCT_ICONS: Record<string, React.FC<{ className?: string }>> = {
  rabbitmq: RabbitMQIcon,
  n8n: N8NIcon,
  strapi: StrapiIcon,
  medusa: MedusaIcon,
  odoo: OdooIcon,
  idurar: IdurarIcon,
  'frappe-education': FrappeEducationIcon,
  redis: RedisIcon,
};

export const getProductIcon = (key: string): React.FC<{ className?: string }> =>
  PRODUCT_ICONS[key] || RabbitMQIcon;
